import { useCallback } from 'react'

import { validatePhoneNumbers } from '@/features/domain/order/actions/validatePhoneNumbers'
import { useAppDispatch } from '@/store'

import { useTexts } from './useTexts'

export function usePhoneValidation() {
  const texts = useTexts()
  const dispatch = useAppDispatch()

  return useCallback(
    async (
      phoneNumber: string,
      status: uui.domain.server.rm.VoiceConfig['status'],
      callbackConfigStatus: 'BACK_OFFICE' | 'OFF',
    ) => {
      if (status !== 'ADVANCED' || callbackConfigStatus === 'OFF')
        return { phoneNumberRequiredError: null, phoneNumberValidError: null }

      const requiredError = phoneNumber?.trim().length === 0
      if (requiredError) {
        return {
          phoneNumberRequiredError: {
            id: 'phoneNumberRequiredError',
            field: 'backOfficePhone' as const,
            message: texts.backOfficePhone.error.required,
            priority: 10,
          },
          phoneNumberValidError: null,
        }
      }

      // Server validation
      const thunkResult = await dispatch(validatePhoneNumbers([phoneNumber]))

      if (!validatePhoneNumbers.fulfilled.match(thunkResult)) {
        throw new Error(thunkResult.payload?.message ?? 'Internal error')
      }

      if (!thunkResult.payload[phoneNumber]) {
        return {
          phoneNumberValidError: {
            id: 'phoneNumberValidError',
            message: texts.backOfficePhone.error.format,
            field: 'backOfficePhone' as const,
            priority: 10,
          },
          phoneNumberRequiredError: null,
        }
      }

      return { phoneNumberRequiredError: null, phoneNumberValidError: null }
    },
    [dispatch, texts],
  )
}
